import React from 'react';
import { Redirect } from 'react-router-dom';
import get from 'lodash/get';

// returns false if no redirect is necessary
const redirectByFormValidation = (
  currentPath,
  formData,
  offer,
  cashBalance,
  pendingTransfers,
  accountRestrictions,
) => {
  const splitPath = currentPath.split('/');
  const finalPath = splitPath.slice(-1)[0];
  const cleanUrl = splitPath.slice(0, (splitPath.length - 1)).join('/');

  const shareQuantityOrTotalInvestment = get(formData, 'externalOfferOrderAmount.quantity') || get(formData, 'externalOfferOrderAmount.totalInvestment');

  switch (finalPath) {
    case 'amount':
      // FINRA restricted accounts can't invest
      if (accountRestrictions.length > 0) {
        return <Redirect to={`${cleanUrl}/account-restriction`} />;
      }
      return false;

    case 'disclosures':
      if (shareQuantityOrTotalInvestment &&
        (!offer.allowRestrictedPersons || get(formData, 'externalOfferOrderAmount.unrestricted'))) {
        return false;
      }
      return <Redirect to={`${cleanUrl}/amount`} />;

    case 'payment':
      if (!(shareQuantityOrTotalInvestment) ||
          (offer.allowRestrictedPersons && !get(formData, 'externalOfferOrderAmount.unrestricted'))) {
        return <Redirect to={`${cleanUrl}/amount`} />;
      } else if (!get(formData, 'externalOfferOrderDisclosures.reviewedDocuments', false)) {
        return <Redirect to={`${cleanUrl}/disclosures`} />;
      }
      return false;

    case 'review-order':
      if (!(shareQuantityOrTotalInvestment) ||
          (offer.allowRestrictedPersons && !get(formData, 'externalOfferOrderAmount.unrestricted'))) {
        return <Redirect to={`${cleanUrl}/amount`} />;
      } else if (!get(formData, 'externalOfferOrderDisclosures.reviewedDocuments', false)) {
        return <Redirect to={`${cleanUrl}/disclosures`} />;
      }
      return false;
    case 'confirmation':
      return false;
    default:
      return false;
  }
};

export default redirectByFormValidation;



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/redirectByFormValidation.js